import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-[var(--radius-input)] glass-effect px-token-sm py-token-sm text-base text-white placeholder:text-[color:var(--color-placeholder-text-strong)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-accent-text)]/50 focus-visible:border-[color:var(--color-accent-text)]/50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-all duration-300 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-white",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
